import { FunctionComponent } from "react";
import { StyledIndicator } from "./sort-indicator.styles";
import { faArrowDown, faArrowUp } from "components/icon-library";
interface SortIndicatorProps {
  direction: "asc" | "desc";
}
const SortIndicator: FunctionComponent<SortIndicatorProps> = ({
  direction,
}) => {
  return (
    <StyledIndicator icon={direction === "asc" ? faArrowDown : faArrowUp} />
  );
};

export default SortIndicator;
